const concertKey = "pia-t_";
const drawnKey = "pia-d_";
const tabletKey = "pia-tablet";

class Storage {
  constructor() {
    this.init();
  }
  init() {
    // DrawingStorageのカスとか消したい
  }

  hasUserId(concertId) {
    const item = localStorage.getItem(concertKey + concertId);
    return item != null;
  }

  getUserId(concertId) {
    return localStorage.getItem(concertKey + concertId);
  }
  setUserId(payload) {
    localStorage.setItem(concertKey + payload.concertId, payload.token);
  }
  removeUserId(concertId) {
    localStorage.removeItem(concertKey + concertId);
    this.removeTabletFlag();
  }

  setTabletFlag(){
    localStorage.setItem(tabletKey, "true");
  }

  removeTabletFlag(){
    localStorage.removeItem(tabletKey);
  }

  isTabletTokenFlag() {
    return localStorage.getItem(tabletKey) === "true";
  }

  removeAll() {
    for (let key in localStorage) {
      if (key.indexOf(concertKey) > -1) {
        localStorage.removeItem(key);
      }
      if (key.indexOf(drawnKey) > -1) {
        localStorage.removeItem(key);
      }
    }
  }

  /**
   * 描きこみしましたフラグ取得
   * @param concertId
   * @returns {string}
   */
  getDrawn(concertId) {
    return localStorage.getItem(drawnKey + concertId) === "true";
  }

  /**
   * 描きこみしましたフラグ
   * @param concertId
   */
  setDrawn(concertId) {
    localStorage.setItem(drawnKey + concertId, "true");
  }

  /**
   * 書き込みを消した
   * @param concertId
   */
  removeDrawn(concertId) {
    localStorage.removeItem(drawnKey + concertId);
  }

}

export default new Storage();
